const lazy = {
    webpSupport : false,
    observer : false,
    init( selector ) {
        lazy.webpSupport = lazy.checkFormatSupport(); // check for webp support
        if( lazy.observer !== false ) lazy.add( selector ); //if there is an observer don't make a new one
        lazy.observer = new IntersectionObserver( images => {
            images.forEach( (image, idx) => {
                if( image.isIntersecting ) { 
                    lazy.loadImage( image.target )
                    lazy.observer.unobserve( image.target )
                }
            } )
        }, { 
            threshold : 0.1, //load image when it is 10% offscreen
            rootMargin : "0px"
        } ) 
        lazy.add( selector ); //find and add images
    },
    loadImage( image ) {
        image = image || false;
        if( !image ) return;
        let src = image.getAttribute('data-src');
        if( lazy.webpSupport ) {
            const oSRC = src; //original source
            if( image.tagName === 'IMG' ) {
                image.onerror = (e) => { e.target.onerror=null; e.target.src=oSRC; } //this should automatically replace missing webp versions with original
            }
            // src = lazy.webpConvert( src ); //use WebP version
        } 
        image.tagName == 'IMG' ? image.setAttribute('src', src) : image.style.backgroundImage = `url(${src})`;
        image.classList.add('loaded');
    },
    add( selector ) {
        selector = selector || '[data-src]'; //allow for other selectors
        const images = typeof selector === 'string' || selector instanceof String ? document.querySelectorAll(selector) : [];
        if( images.length < 1 ) return; //if no images escape
        images.forEach( image => { 
            if( !image.classList.contains( 'loaded' ) ) { //ignore anything already loaded
                lazy.observer.observe( image ) //send to intersection observer
            }
        });
        return;
    },
    checkFormatSupport() { //try to load a webp image, if error set false
        var elem = document.createElement('canvas');
        if (!!(elem.getContext && elem.getContext('2d'))) return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
        return false;
    },
    webpConvert : ( src ) => {
        const exclude = [ 'png', 'svg', 'gif', 'webp' ];
        src = src || false;
        if( !src ) return
        const file = src.split('.');
        return !exclude.includes( file.pop() ) ? `${src}.webp` : src; 
    }
}

module.exports = lazy;